import React from "react";

export default function MySQL_SYSTEM_USER() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_SYSTEM_USER</h1>
      <p>This is the MySQL_SYSTEM_USER component generated from the SQL JSON.</p>
    </div>
  );
}
